import { AxiosInstance } from 'axios';
export { SourceTypeIds, toSourceTypeId } from './SourceTypeIds';
export type { SourceTypeId } from './SourceTypeIds';
import { SourceTypeIds, SourceTypeId } from './SourceTypeIds';
import { AltusSourceSettingsApi } from './altus';
import { AsanaSourceSettingsApi } from './asana';
import { ClickUpSourceSettingsApi } from './clickup';
import { CdsSourceSettingsApi } from './cds';
import { MondaySourceSettingsApi } from './monday';
import { GoogleCalendarSourceSettingsApi } from './googlecalendar';
import { GoogleDriveSourceSettingsApi } from './googledrive';
import { GoogleTasksSourceSettingsApi } from './googletasks';
import { ConfluenceSourceSettingsApi } from './confluence';
import { GmailSourceSettingsApi } from './gmail';
import { GitHubSourceSettingsApi } from './github';
import { GitLabSourceSettingsApi } from './gitlab';
import { JiraSourceSettingsApi } from './jira';
import { OneNoteSourceSettingsApi } from './onenote';
import { NotionSourceSettingsApi } from './notion';
import { OutlookSourceSettingsApi } from './outlook';
import { PlannerSourceSettingsApi } from './planner';
import { Project4TWSourceSettingsApi } from './project4tw';
import { SharePointSourceSettingsApi } from './sharepoint';
import { SlackSourceSettingsApi } from './slack';
import { SalesforceSourceSettingsApi } from './salesforce';
import { TodoistSourceSettingsApi } from './todoist';
import { TrelloSourceSettingsApi } from './trello';
import { VstsSourceSettingsApi } from './vsts';
import { ZendeskSourceSettingsApi } from './zendesk';


export type SourceSettingsApiModule =
  | AltusSourceSettingsApi
  | AsanaSourceSettingsApi
  | CdsSourceSettingsApi
  | ClickUpSourceSettingsApi
  | GoogleCalendarSourceSettingsApi
  | GoogleDriveSourceSettingsApi
  | GoogleTasksSourceSettingsApi
  | MondaySourceSettingsApi
  | ConfluenceSourceSettingsApi
  | GmailSourceSettingsApi
  | GitHubSourceSettingsApi
  | GitLabSourceSettingsApi
  | JiraSourceSettingsApi
  | Project4TWSourceSettingsApi
  | OneNoteSourceSettingsApi
  | NotionSourceSettingsApi
  | OutlookSourceSettingsApi
  | PlannerSourceSettingsApi
  | SharePointSourceSettingsApi
  | SlackSourceSettingsApi
  | SalesforceSourceSettingsApi
  | TodoistSourceSettingsApi
  | TrelloSourceSettingsApi
  | VstsSourceSettingsApi
  | ZendeskSourceSettingsApi;

export class SourceSettingsApiRegistry {
  private readonly registry = new Map<SourceTypeId, SourceSettingsApiModule>();

  constructor(client: AxiosInstance) {
    this.registerSourceApi(SourceTypeIds.Altus, new AltusSourceSettingsApi(client));
    const cdsApi = new CdsSourceSettingsApi(client);
    this.registerSourceApi(SourceTypeIds.AltusLists, cdsApi);
    this.registerSourceApi(SourceTypeIds.Asana, new AsanaSourceSettingsApi(client));
    this.registerSourceApi(SourceTypeIds.Cds, cdsApi);
    this.registerSourceApi(SourceTypeIds.ClickUp, new ClickUpSourceSettingsApi(client));
    this.registerSourceApi(SourceTypeIds.Monday, new MondaySourceSettingsApi(client));
    this.registerSourceApi(SourceTypeIds.GoogleCalendar, new GoogleCalendarSourceSettingsApi(client));
    this.registerSourceApi(SourceTypeIds.GoogleDrive, new GoogleDriveSourceSettingsApi(client));
    this.registerSourceApi(SourceTypeIds.GoogleTasks, new GoogleTasksSourceSettingsApi(client));
    this.registerSourceApi(SourceTypeIds.Confluence, new ConfluenceSourceSettingsApi(client));
    this.registerSourceApi(SourceTypeIds.Gmail, new GmailSourceSettingsApi(client));
    this.registerSourceApi(SourceTypeIds.GitHub, new GitHubSourceSettingsApi(client));
    this.registerSourceApi(SourceTypeIds.GitLab, new GitLabSourceSettingsApi(client));
    this.registerSourceApi(SourceTypeIds.Jira, new JiraSourceSettingsApi(client));
    this.registerSourceApi(SourceTypeIds.MSProject4TW, new Project4TWSourceSettingsApi(client));
    this.registerSourceApi(SourceTypeIds.OneNote, new OneNoteSourceSettingsApi(client));
    this.registerSourceApi(SourceTypeIds.Notion, new NotionSourceSettingsApi(client));
    this.registerSourceApi(
      SourceTypeIds.MicrosoftPlanner,
      new PlannerSourceSettingsApi(client),
    );
    this.registerSourceApi(
      SourceTypeIds.SharePoint,
      new SharePointSourceSettingsApi(client),
    );
    this.registerSourceApi(SourceTypeIds.Slack, new SlackSourceSettingsApi(client));
    this.registerSourceApi(SourceTypeIds.Salesforce, new SalesforceSourceSettingsApi(client));
    this.registerSourceApi(SourceTypeIds.Todoist, new TodoistSourceSettingsApi(client));
    const outlook = new OutlookSourceSettingsApi(client);
    this.registerSourceApi(SourceTypeIds.OutlookMail, outlook);
    this.registerSourceApi(SourceTypeIds.OutlookTasks, outlook);
    this.registerSourceApi(SourceTypeIds.OutlookCalendar, outlook);
    this.registerSourceApi(SourceTypeIds.Trello, new TrelloSourceSettingsApi(client));
    this.registerSourceApi(SourceTypeIds.Vsts, new VstsSourceSettingsApi(client));
    this.registerSourceApi(SourceTypeIds.Zendesk, new ZendeskSourceSettingsApi(client));
  }

  registerSourceApi(
    sourceTypeId: SourceTypeId,
    apiModule: SourceSettingsApiModule,
  ): void {
    this.registry.set(sourceTypeId, apiModule);
  }

  tryGetSourceApi<T extends SourceSettingsApiModule>(
    sourceTypeId: SourceTypeId,
  ): T | null {
    return (this.registry.get(sourceTypeId) as T | undefined) || null;
  }

  getSourceApi<T extends SourceSettingsApiModule>(sourceTypeId: SourceTypeId): T {
    const api = this.tryGetSourceApi<T>(sourceTypeId);
    if (!api) {
      throw new Error(
        `No source settings API module registered for source: ${sourceTypeId}`,
      );
    }

    return api;
  }

  hasSourceApi(sourceTypeId: SourceTypeId): boolean {
    return this.registry.has(sourceTypeId);
  }

  getRegisteredSourceTypeIds(): SourceTypeId[] {
    return Array.from(this.registry.keys()).sort();
  }
}

// Backward-compatible alias for existing consumers.
export { SourceSettingsApiRegistry as ConnectionSourceSettingsApi };